let v9736 = typeof location != "undefined";
const vP12318 = require("../data/colors.js");
const THREE = require("three");
const UTILS = require("./utils.js");
const config = require("../config.js");
const vLN324 = 32;
const vLN253 = 2.5;
const vLN10003 = 1000;
class Zone extends THREE.Object3D {
  static fromConfig(p12319, p12320) {
    return new Zone(p12319.zoneSize, p12319.zoneSpeed, p12319.zoneRnd, p12319.zoneCol0, p12319.zoneCol1, p12319.zoneCol2, p12319.zoneHeight, p12319.zoneStages, p12319.zoneWait, p12320);
  }
  constructor(p12321, p12322, p12323, p12324, p12325, p12326, p12327, p12328, p12329, p12330) {
    super();
    this.randomEndPoint = !!p12323;
    p12329 = UTILS.isNumber(p12329) ? p12329 : 0;
    this.waitTimer = UTILS.limitMM(p12329 || 0, config.minZoneWait, config.maxZoneWait) * 1000;
    p12328 = UTILS.isNumber(p12328) ? p12328 : 0;
    this.stages = UTILS.limitMM(p12328 || 0, config.minZoneStages, config.maxZoneStages);
    this._waitTimer = this.waitTimer;
    this._stages = this.stages;
    this._size = UTILS.limitMM(p12321 || 50, config.minZoneSize, config.maxZoneSize);
    this._height = UTILS.limitMM(p12327 || vLN10003, config.minZoneHeight, config.maxZoneHeight);
    this.circleSize = new THREE.Vector3();
    this.circlePosition = new THREE.Vector3();
    this.targetCircleSize = new THREE.Vector3();
    this.targetCirclePosition = new THREE.Vector3();
    this.circleShrinkSpeed = vLN253 * UTILS.limitMM(p12322 || 1, config.minShrinkSpeed, config.maxShrinkSpeed);
    if (p12330) {
      let vO307 = {
        src: "zone_0",
        repeatX: 20,
        repeatY: 20
      };
      let v9737 = new THREE.MeshBasicMaterial({
        color: "#ffffff",
        depthWrite: false,
        flatShading: false,
        vertexColors: true,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5
      });
      v9737.onBeforeCompile = p12331 => {
        if (p12331.defines) {
          p12331.defines.USE_UV = "";
        } else {
          p12331.defines = {
            USE_UV: ""
          };
        }
        p12331.uniforms.firstColor = {
          value: new THREE.Color(p12324 || vP12318.zone.BR[0])
        };
        p12331.uniforms.middleColor = {
          value: new THREE.Color(p12325 || vP12318.zone.BR[1])
        };
        p12331.uniforms.endColor = {
          value: new THREE.Color(p12326 || vP12318.zone.BR[2])
        };
        p12331.fragmentShader = "\n\t\t\t\t\tvarying vec2 vUv_kr;\n\t\t\t\t\tuniform vec3 firstColor;\n\t\t\t\t\tuniform vec3 middleColor;\n\t\t\t\t\tuniform vec3 endColor;\n\t\t\t\t\tvec2 RES = vec2(512,512);\n\t\t\t\t\tvec3 getGradient(vec2 coord) {\n\t\t\t\t\t\tvec2 xy = coord.yx / RES;\n\t\t\t\t\t\tfloat h = 0.5; // adjust position of middleColor\n\t\t\t\t\t\tvec3 col = mix(mix(endColor, middleColor, xy.x/h), mix(middleColor, firstColor, (xy.x - h)/(1.0 - h)), step(h, xy.x));\n\n\t\t\t\t\t\treturn col;\n\t\t\t\t\t}\n\t\t\t\t" + p12331.fragmentShader.replace("#include <dithering_fragment>", "\n\t\t\t\t\t#include <dithering_fragment>\n\t\t\t\t\tgl_FragColor.rgb *= getGradient(RES*vUv_kr);\n\t\t\t\t");
        p12331.vertexShader = "\n\t\t\t\t\tvarying vec2 vUv_kr;\n\t\t\t\t" + p12331.vertexShader.replace("#include <fog_vertex>", "\n\t\t\t\t\t#include <fog_vertex>\n\t\t\t\t\tvUv_kr=uv;\n\t\t\t\t");
      };
      if (vO307.src) {
        p12330.loadTexture(v9737, vO307.src, vO307);
      }
      let v9738 = new THREE.CylinderGeometry(1, 1, 1, vLN324, vLN324, true);
      v9738.computeBoundingBox();
      v9738.computeBoundingSphere();
      v9738.computeVertexNormals(true);
      this.baseMesh = new THREE.Mesh(v9738, v9737);
    }
    this.reset();
    if (p12330) {
      this.add(this.baseMesh);
    }
  }
  animate(p12332) {
    if (this.baseMesh && this.baseMesh.material.map) {
      this.baseMesh.material.map.offset.y += p12332 * 0.00003;
    }
  }
  update(p12333, p12334, p12335) {
    if (v9736) {
      if (this.shrinkTween) {
        this.shrinkTween.stop();
      }
      this.shrinkTween = new TWEEN.Tween(this.scale).to({
        x: p12334[2],
        z: p12334[3]
      }, 900).easing(TWEEN.Easing.Linear.None).start();
      if (this.moveTween) {
        this.moveTween.stop();
      }
      this.moveTween = new TWEEN.Tween(this.position).to({
        x: p12334[0],
        z: p12334[1]
      }, 900).easing(TWEEN.Easing.Linear.None).start();
      if (p12334[2] <= 0 || p12334[3] <= 0) {
        this.visible = false;
      }
    } else {
      if (this.circleSize.x <= this.targetCircleSize.x && this.circleSize.z <= this.targetCircleSize.z) {
        if (this.stages) {
          this.waitTimer -= p12333 * 1000;
          if (!this.waiting) {
            this.waiting = true;
            var vO308 = {
              time: this.waitTimer,
              contTime: true,
              canDMG: true,
              msg: "Zone closing in "
            };
            if (p12335.waitTimers) {
              p12335.waitTimers.push(vO308);
            } else {
              p12335.waitTimers = [vO308];
            }
          }
          if (this.waitTimer <= 0) {
            this.waitTimer = this._waitTimer;
            this.stages--;
            this.nextCircle();
          }
        }
        return;
      }
      var v9739 = new THREE.Vector3().subVectors(this.targetCircleSize, this.circleSize).normalize();
      var v9740 = new THREE.Vector3().addVectors(this.circleSize, v9739.multiplyScalar(p12333 * this.circleShrinkSpeed));
      var v9741 = new THREE.Vector3().subVectors(this.targetCirclePosition, this.circlePosition).normalize();
      var v9742 = new THREE.Vector3().addVectors(this.circlePosition, v9741.multiplyScalar(p12333 * this.circleShrinkSpeed));
      this.setCircleSize(v9742, v9740);
    }
  }
  reset() {
    if (v9736) {
      this.scale.set(this._size, this._height, this._size);
      this.position.set(0, 0, 0);
      this.visible = true;
    } else {
      this.waitTimer = this._waitTimer;
      this.stages = this._stages;
      this.waiting = false;
      this.setCircleSize(new THREE.Vector3(0, 0, 0), new THREE.Vector3(this._size, this._height, this._size));
      this.nextCircle();
    }
  }
  nextCircle() {
    this.waiting = false;
    var v9743 = this.generateTargetCircle();
    this.setTargetCircle(new THREE.Vector3(v9743[0], 0, v9743[1]), new THREE.Vector3(this.stages ? this.circleSize.x / 2 : 0, 0, this.stages ? this.circleSize.x / 2 : 0));
  }
  isOutside(p12336) {
    return UTILS.getDistance(p12336.x, p12336.z, this.circlePosition.x, this.circlePosition.z) > this.circleSize.x;
  }
  getData() {
    return [this.circlePosition.x, this.circlePosition.z, this.circleSize.x, this.circleSize.z];
  }
  setTargetCircle(p12337, p12338) {
    this.targetCirclePosition = p12337;
    this.targetCircleSize = p12338;
  }
  setCircleSize(p12339, p12340) {
    this.circlePosition = p12339;
    this.circleSize = p12340;
  }
  generateTargetCircle() {
    if (!this.randomEndPoint) {
      return [0, 0];
    }
    var v9744 = Math.random() * 2 * Math.PI;
    var v9745 = this.circleSize.x / 2 * Math.sqrt(Math.random());
    var v9746 = v9745 * Math.cos(v9744);
    var v9747 = v9745 * Math.sin(v9744);
    return [v9746, v9747];
  }
}
Zone.CONFIG_PROPS = ["zoneSize", "zoneSpeed", "zoneRnd", "zoneCol0", "zoneCol1", "zoneCol2", "zoneHeight", "zoneStages", "zoneWait"];
module.exports = Zone;